import type {
    OnboardingPropertyCountPagePropertyOnboardingContextFieldsV1,
    OnboardingPropertyCountPagePropertyOnboardingContextIdsV1,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    BackElementPropertyOnboardingManifestV1,
    MultipleUnitsPropertyCardElementPropertyOnboardingManifestV1,
    NextElementPropertyOnboardingManifestV1,
    OkayElementPropertyOnboardingManifestV1,
    OneUnitPropertyCardElementPropertyOnboardingManifestV1,
    PropertiesInDifferentLocationsLinkElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import {
    OnboardingPropertyCountPagePropertyOnboardingContextManifestV1,
    WebOnboardingPropertyCountVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/onboarding-property-count-page";
import { BaseContextFieldsMapping } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const singleMultipleBinder = defineBinder(({ webAnalytics, action: { hover, click, reveal } }) => {
    webAnalytics.pageContext<
        OnboardingPropertyCountPagePropertyOnboardingContextIdsV1,
        OnboardingPropertyCountPagePropertyOnboardingContextFieldsV1
    >(OnboardingPropertyCountPagePropertyOnboardingContextManifestV1.ids, {
        auth_user_id: BaseContextFieldsMapping.auth_user_id,
        member_id: BaseContextFieldsMapping.member_id,
        property_id: BaseContextFieldsMapping.property_id,
        is_internal_user: BaseContextFieldsMapping.is_internal_user,
    });

    webAnalytics.observe(WebOnboardingPropertyCountVisitEventPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, hover, reveal], OneUnitPropertyCardElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement(
        [click, hover, reveal],
        MultipleUnitsPropertyCardElementPropertyOnboardingManifestV1.ids,
        {},
    );
    webAnalytics.observeElement([click], BackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], NextElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement(
        [click, reveal],
        PropertiesInDifferentLocationsLinkElementPropertyOnboardingManifestV1.ids,
        {},
    );
    webAnalytics.observeElement([click], OkayElementPropertyOnboardingManifestV1.ids, {});
});
